import { render } from "./VaPageNotFoundSimple.vue?vue&type=template&id=bf6e59b4"
import script from "./VaPageNotFoundSimple.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundSimple.vue?vue&type=script&lang=js"

import "./VaPageNotFoundSimple.vue?vue&type=style&index=0&id=bf6e59b4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__